module.exports = __webpack_public_path__ + "fa-light-300.woff?5024e9b25bf8074067819efc65c4bd66";